function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m192 384c105.863281 0 192-86.128906 192-192 0-51.328125-19.960938-99.550781-56.207031-135.792969-36.25-36.246093-84.464844-56.207031-135.792969-56.207031-105.871094 0-192 86.128906-192 192 0 51.328125 19.960938 99.550781 56.207031 135.792969 36.242188 36.246093 84.464844 56.207031 135.792969 56.207031zm0-32c-37.390625 0-72.800781-12.710938-101.296875-36.078125l225.21875-225.21875c23.367187 28.496094 36.078125 63.90625 36.078125 101.296875 0 88.222656-71.777344 160-160 160zm0-320c37.382812 0 72.800781 12.710938 101.289062 36.078125l-225.210937 225.21875c-23.367187-28.496094-36.078125-63.90625-36.078125-101.296875 0-88.222656 71.777344-160 160-160zm0 0"
});

var SvgNoImg = function SvgNoImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "384pt",
    viewBox: "0 0 384 384",
    width: "384pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NoImg.7f7af9bb.svg";
export { ForwardRef as ReactComponent };